export default "__VITE_ASSET__aDPxBVET__"